export const environment = {
  production: false,
  apiUrl: 'https://cronica.singleclick.co/api',
  wordpressUrl: 'https://wpcronica.singleclick.co',
};